import React from 'react';

import { Col } from 'antd';

type Props = {
  span: number;
  children?: React.ReactElement;
};

const CenteredCardColumn = (props: Props) => {
  return (
    <Col
      span={props.span}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        flexDirection: 'column',
      }}>
      {props.children}
    </Col>
  );
};

export default CenteredCardColumn;
